module.exports = __webpack_public_path__ + "img/pc.b7cb7b8e.jpg";